import React from 'react';

interface EditIconProps {
  width?: number;
  height?: number;
  className?: string;
}

const EditIcon: React.FC<EditIconProps> = ({ 
  width = 14, 
  height = 14, 
  className = '' 
}) => (
  <svg 
    width={width} 
    height={height} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2"
    className={className}
  >
    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
    <path d="m18.5 2.5 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
  </svg>
);

export default EditIcon;

